"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;padding:", (0, _util.rem)(9), " ", (0, _util.rem)(40), " ", (0, _util.rem)(8), " ", (0, _util.rem)(16), ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-radius:", (0, _util.rem)(6), ";position:relative;transition:margin 0.3s;&>span{line-height:0;svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";margin-right:", theme.spacing[10], ";}}&>button{position:absolute;right:", (0, _util.rem)(16), ";top:", (0, _util.rem)(12), ";cursor:pointer;display:flex;align-items:center;svg{width:", (0, _util.rem)(16), ";height:", (0, _util.rem)(16), ";color:", theme.color.monochrome.mediumDark, ";}&:hover svg{color:", theme.color.monochrome.dark, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var info = function info(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.primary.brand, ";background-color:", theme.color.secondary.brand, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:info;"));
};

var negative = function negative(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.primary.negative, ";background-color:", theme.color.secondary.negative, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:negative;"));
};

var warning = function warning(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";color:", theme.color.warning[700], ";background-color:", theme.color.secondary.warning, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:warning;"));
};

var styles = {
  info: info,
  warning: warning,
  negative: negative
};
exports.styles = styles;
//# sourceMappingURL=MessageCard.styles.js.map